var _path, _path2, _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadlineShapes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1398,
    height: 722,
    viewBox: "0 0 1398 722",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1383.58 130.028C1374.95 114.705 1362.83 101.631 1348.21 91.863C1333.58 82.0953 1316.86 75.9088 1299.4 73.8046C1281.94 71.7003 1264.23 73.7374 1247.7 79.751C1231.18 85.7645 1216.3 95.5853 1204.27 108.418C1192.25 121.251 1183.41 136.736 1178.49 153.618C1173.56 170.5 1172.68 188.306 1175.91 205.593C1179.14 222.88 1186.4 239.162 1197.1 253.122C1207.8 267.081 1221.63 278.326 1237.48 285.945L1258.36 242.508C1249.33 238.168 1241.45 231.762 1235.35 223.809C1229.26 215.856 1225.12 206.58 1223.28 196.732C1221.44 186.883 1221.94 176.74 1224.75 167.122C1227.56 157.504 1232.59 148.683 1239.44 141.372C1246.29 134.061 1254.77 128.466 1264.18 125.04C1273.6 121.614 1283.69 120.453 1293.63 121.652C1303.58 122.851 1313.11 126.375 1321.44 131.94C1329.77 137.505 1336.67 144.953 1341.59 153.682L1383.58 130.028Z",
    fill: "#6070FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246.234 705.783C248.556 703.017 250.195 699.743 251.016 696.226C251.838 692.709 251.82 689.048 250.963 685.539C250.107 682.031 248.436 678.773 246.087 676.031C243.737 673.288 240.775 671.137 237.439 669.752C234.104 668.367 230.489 667.787 226.888 668.059C223.287 668.331 219.8 669.447 216.71 671.317C213.621 673.187 211.015 675.758 209.103 678.823C207.192 681.887 206.03 685.358 205.71 688.956L215.568 689.833C215.75 687.783 216.412 685.805 217.501 684.06C218.59 682.314 220.075 680.849 221.835 679.784C223.595 678.718 225.581 678.082 227.633 677.928C229.685 677.773 231.744 678.103 233.644 678.892C235.544 679.681 237.232 680.907 238.571 682.469C239.909 684.032 240.861 685.887 241.349 687.886C241.837 689.885 241.847 691.971 241.379 693.974C240.911 695.978 239.977 697.843 238.654 699.419L246.234 705.783Z",
    fill: "#EBEBFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1112,
    y: 102,
    width: 204,
    height: 47,
    transform: "rotate(-30 1112 102)",
    fill: "#EBEBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 697.44,
    y: 631,
    width: 161.407,
    height: 28.875,
    transform: "rotate(23.34 697.44 631)",
    fill: "#EBEBFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 56.0124,
    height: 10.0203,
    transform: "matrix(0.977401 -0.211395 -0.211395 -0.977401 659.253 142.572)",
    fill: "#6070FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.601562,
    y: 99.9232,
    width: 108.669,
    height: 19.4403,
    transform: "rotate(-46.1415 0.601562 99.9232)",
    fill: "#EBEBFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 828.5,
    cy: 662.5,
    r: 23.5,
    fill: "#6070FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.5,
    cy: 149.5,
    r: 11.5,
    fill: "#EBEBFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1177.5,
    cy: 562.5,
    r: 37,
    fill: "white",
    stroke: "#EBEBFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19,
    transform: "matrix(1 0 0 -1 931 73)",
    fill: "white",
    stroke: "#EBEBFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.5,
    cy: 53.5,
    r: 7,
    fill: "white",
    stroke: "#EBEBFF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11,
    transform: "matrix(1 0 0 -1 39 416)",
    fill: "white",
    stroke: "#EBEBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9842 73.0741C42.7936 82.8892 42.6736 93.967 46.6508 103.87C50.6279 113.774 58.3763 121.692 68.1914 125.883C78.0065 130.073 89.0843 130.193 98.9878 126.216C108.891 122.239 116.809 114.49 121 104.675L46.9842 73.0741Z",
    fill: "#6070FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.155 650C220.821 654.881 222.439 659.695 225.654 663.383C228.87 667.071 233.418 669.331 238.299 669.666C243.181 670 247.995 668.381 251.683 665.166C255.371 661.951 257.63 657.403 257.965 652.521L221.155 650Z",
    fill: "#6070FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadlineShapes);
export default __webpack_public_path__ + "static/media/headline-shapes.4e139ce89ac0a8112fe147147591c3ef.svg";
export { ForwardRef as ReactComponent };